import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  drawerItems: {
    padding: theme.spacing(1),
  },
  scrollableContainer: {
    maxHeight: 245,
    overflowY: 'auto',
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
  },
  typeLabel: {
    width: '35%',
  },
  textField: {
    width: '65%',
  },
  select: {
    width: '65%',
  },
  dateTimePicker: {
    width: '65%',
  },
}));
